import Request from './Request';
const axios = require('axios');
const constant = require('../constants/constant').default;
export default class OrbitFilesService {
    static async list(params = {}) {
        const qs = new URLSearchParams(
            Object.fromEntries(Object.entries(params).filter(([, v]) => v != null && v !== ''))
        ).toString();
        return Request.get(`/api/orbit/files${qs ? '?' + qs : ''}`);
    }

    static async getContextAvailability(ids = []) {
        const qs = new URLSearchParams();
        ids.filter((id) => Number.isFinite(id)).forEach((id) => qs.append('ids[]', String(id)));
        return Request.get(`/api/orbit/files/context-availability${qs.toString() ? '?' + qs.toString() : ''}`);
    }

    static async upload(file, { clientId, conversationId } = {}) {
        const token = localStorage.getItem('access_token');
        const form  = new FormData();
        form.append('file', file);
        if (clientId)       form.append('client_id',       clientId);
        if (conversationId) form.append('conversation_id', conversationId);
        const response = await axios.post(
            constant.BACKEND_DOMAIN + '/api/orbit/files',
            form,
            { headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'multipart/form-data' } }
        );
        return response?.data;
    }
    static async getDownloadUrl(id) {
        return Request.get(`/api/orbit/files/${id}/download`);
    }

    static async getContextUpload(id) {
        return Request.get(`/api/orbit/files/${id}/context-upload`, null, false, true);
    }

    static async delete(id) {
        return Request._delete(`/api/orbit/files/${id}`);
    }
}
